import React from "react";

import { LaptopMinimal } from "lucide-react";

import AndroidIcon from "../common/icons/AndroidIcon";
import AndroidTvIcon from "../common/icons/AndroidTvIcon";
import AppleTvIcon from "../common/icons/AppleTvIcon";
import FireTvIcon from "../common/icons/FireTvIcon";
import IosIcon from "../common/icons/IosIcon";
import RokuIcon from "../common/icons/RokuIcon";
import TizenIcon from "../common/icons/TizenIcon";

import type { ComponentType, JSX } from "react";

import type { FilterOption } from "../dataTable/dataTable.types";

interface IIconByPlatform {
  platform: string;
  className?: string;
}

interface PlatformIconProps {
  className?: string;
}

// Logos PNG noirs, non teintables : atténués pour passer en gris.
const PLATFORM_ICON_CLASS =
  "text-muted-foreground h-5 w-auto [img&]:opacity-60";

const PLATFORM_ICONS: Record<string, ComponentType<PlatformIconProps>> = {
  web: LaptopMinimal,
  ios: IosIcon,
  android: AndroidIcon,
  tvos: AppleTvIcon,
  firetv: FireTvIcon,
  roku: RokuIcon,
  androidtv: AndroidTvIcon,
  tizen: TizenIcon,
};

export function hasPlatformIcon(platform: string): boolean {
  return PLATFORM_ICONS[platform] !== undefined;
}

function IconByPlatform({
  platform,
  className = PLATFORM_ICON_CLASS,
}: IIconByPlatform): JSX.Element | null {
  const PlatformIcon = PLATFORM_ICONS[platform];
  if (!PlatformIcon) return null;

  return <PlatformIcon className={className} />;
}

export function getPlatformFilterOptions(
  getLabel: (platform: string) => string,
): FilterOption[] {
  return Object.keys(PLATFORM_ICONS).map((platform) => ({
    value: platform,
    label: getLabel(platform),
    icon: <IconByPlatform className="h-3.5 w-auto" platform={platform} />,
  }));
}

export default IconByPlatform;
